

  <div style="min-height: 100vh; overflow: hidden;" class="hold-transition login-page">
    <div class="login-box">
      <div class="login-logo">
        <p >Forgot Password</p>
      </div>
      <!-- /.login-logo -->
      <div class="login-box-body">
        <p class="login-box-msg">Enter your email to recover password. </p>
  
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
          <div class="form-group has-feedback">
            <input type="email" formControlName="email" class="form-control" placeholder="Email">
            <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
            <p *ngIf="forgotPasswordForm.controls.email.touched || isFormSubmitted">
              <app-form-validation-errors errorPrefix="Email " [errors]="forgotPasswordForm.get('email').errors"></app-form-validation-errors>
            </p>
          </div>
         
          <div class="row">       
           
            <div class="col-xs-12">
              <button type="submit" [disabled]="!forgotPasswordForm.valid" [ngClass]="{ 'submit-btn-disable': !forgotPasswordForm.valid }" class="btn btn-primary btn-block btn-flat">Submit</button>
              
            </div>
            <!-- /.col -->
          </div>
        </form>
  
        <div class="social-auth-links text-center"></div>
        <!-- /.social-auth-links -->
     
       
     
      </div>
      <!-- /.login-box-body -->
      <!--<app-forgot-password></app-forgot-password>-->
    </div>
  </div>
  